<app-page-base title="Mail is verzonden!"></app-page-base>
